export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', description: '浏览全部电影资源', icon: 'ri-movie-2-line', count: 12 },
  { name: '科幻', slug: 'scifi', description: '探索未来世界的无限可能', icon: 'ri-rocket-2-line', count: 2 },
  { name: '动作', slug: 'action', description: '热血刺激的动作大片', icon: 'ri-fire-line', count: 3 },
  { name: '喜剧', slug: 'comedy', description: '欢乐不断的喜剧佳作', icon: 'ri-emotion-laugh-line', count: 2 },
  { name: '悬疑', slug: 'suspense', description: '扣人心弦的悬疑故事', icon: 'ri-search-eye-line', count: 1 },
  { name: '爱情', slug: 'romance', description: '感人至深的爱情故事', icon: 'ri-heart-line', count: 1 },
  { name: '动画', slug: 'animation', description: '精彩绝伦的动画世界', icon: 'ri-palette-line', count: 2 },
  { name: '剧情', slug: 'drama', description: '深刻隽永的剧情佳作', icon: 'ri-clapperboard-line', count: 1 },
];